var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.6,
    width: 20.8,
    height: 20.8,
    rx: 6,
    stroke: "#36F6FF",
    strokeOpacity: 0.45,
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.3,
    y: 8.3,
    width: 7.8,
    height: 7.8,
    rx: 2.2,
    stroke: "#36F6FF",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 8.3V7.9C13.4 6.68 12.42 5.7 11.2 5.7H8.1C6.88 5.7 5.9 6.68 5.9 7.9V11C5.9 12.22 6.88 13.2 8.1 13.2H8.5",
    stroke: "#36F6FF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabCopyIcon);
export default __webpack_public_path__ + "static/media/tc_cab_copy_icon.0523b169759d8d23c9c382538df585b1.svg";
export { ForwardRef as ReactComponent };